export const USER_FEEDBACK_WITHDRAWAL = {
  feature: 'withdraw',
  categories: [
    {
      value: 'withdraw_all',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_withdraw_all',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_withdraw_all',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'instruction',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_instruction',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_instruction',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'supported_bank',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_supported_bank',
          start: 1,
          end: 3,
        },
      ],
    },
    {
      value: 'process',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_process',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_process',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'success_rate',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_success_rate',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_success_rate',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};

export const USER_FEEDBACK_USER_MANAGEMENT = {
  feature: 'user_management',
  categories: [
    {
      value: 'viewonly_not_supported',
      start: 1,
      end: 3,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_viewOnly',
          start: 1,
          end: 3,
        },
      ],
    },
    {
      value: 'process',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_process',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_process',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};

export const USER_FEEDBACK_MANUAL_TOP_UP = {
  feature: 'manual_top_up',
  categories: [
    {
      value: 'va_uniquecode_not_available',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_uniqueCode',
          start: 1,
          end: 3,
        },
      ],
    },
    {
      value: 'process',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_process',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_process',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'instruction',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_instruction',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_instruction',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};

export const USER_FEEDBACK_EXPORT_ACCOUNT_STATEMENT = {
  feature: 'export_account_statement',
  categories: [
    {
      value: 'loading_time',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_loading_time',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_loading_time',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'data_completeness',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_data_completeness',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_data_completeness',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'data_structure',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_data_structure',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_data_structure',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'realtime',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_realtime',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_realtime',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};

export const USER_FEEDBACK_KYB_SUBMIT = {
  feature: 'kyb_submit',
  categories: [
    {
      value: 'submitform_kyb_guide',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_instruction',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_instruction',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'submitform_text_from',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problemFilling',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_noIssuefilling',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'submitform_selfie_photo',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problemCaptureid',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_captureId',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'submitform_upload_document',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problem_uploadDoc',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_noIssue_uploadDoc',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'submitform_requirement',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problem_requirement',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_requirement',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};

export const USER_FEEDBACK_KYB_CLOSE_FORM = {
  feature: 'kyb_closeform',
  categories: [
    {
      value: 'closeform_kyb_guide',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_categoryNegative_instruction',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_categoryPositive_instruction',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'closeform_text_from',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problemFilling',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_noIssuefilling',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'closeform_selfie_photo',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problemCaptureid',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_captureId',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'closeform_upload_document',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problem_uploadDoc',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_noIssue_uploadDoc',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'closeform_requirement',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_problem_requirement',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_requirement',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'closeform_change_mind',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_misstook',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_easyExplanation',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};

export const USER_FEEDBACK_KYB_APPROVED_FIRST_LOGIN = {
  feature: 'kyb_approved_first_login',
  categories: [
    {
      value: 'finish_revision',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_revision',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_noRevision',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'finish_revision_reason',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_unclearReason',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_clearReason',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'finish_sign_agreementfinish_sign_agreement',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_longAgreement',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_quickAgreement',
          start: 4,
          end: 5,
        },
      ],
    },
    {
      value: 'finish_onboarding',
      start: 1,
      end: 5,
      optionRange: [
        {
          label: 'feedbackForm_kyb_longOnboarding',
          start: 1,
          end: 3,
        },
        {
          label: 'feedbackForm_kyb_shortOnboarding',
          start: 4,
          end: 5,
        },
      ],
    },
  ],
};
